var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-0 px-2 py-1 font-weight-medium",class:_vm.bgColorValue,style:(_vm.borderStyles)},[_vm._v(" "+_vm._s(_vm.textValue)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }